import { appendVueRoute, Role } from '@therame/shared';
import { type RouteRecordRaw } from 'vue-router';
import { type RestrictedRecordRaw } from '..';

const routes: Array<RouteRecordRaw> = [
  {
    ...appendVueRoute<'preventionStore'>('preventionStore', '/prevention-programs'),
    component: () => import('@src/views/PreventionOverview.vue'),
    meta: {
      layout: 'default',
      title: 'Kursübersicht',
      requiresAuth: true,
      requiresOnboarding: true,
      noPadding: true,
      accessPossibleWithRoles: [
        Role.ADMIN,
        Role.MANAGEMENT,
        Role.THERAPIST,
        Role.PATIENT,
        Role.PREVENTION,
      ],
    },
  },
  {
    ...appendVueRoute<'preventionStoreDetail'>(
      'preventionStoreDetail',
      '/prevention-programs/:preventionCourseId',
    ),
    component: () => import('@src/views/PreventionDetail.vue'),
    meta: {
      layout: 'default',
      title: 'Kursübersicht',
      requiresAuth: true,
      requiresOnboarding: true,
      accessPossibleWithRoles: [
        Role.ADMIN,
        Role.MANAGEMENT,
        Role.THERAPIST,
        Role.PATIENT,
        Role.PREVENTION,
      ],
    },
  },
  {
    ...appendVueRoute<'preventionExecution'>(
      'preventionExecution',
      '/prevention-execution/:preventionCourseId/:preventionCourseModuleId',
    ),
    component: () => import('@src/views/PreventionExecution.vue'),
    meta: {
      layout: 'default',
      title: 'Kursdurchführung',
      requiresAuth: true,
      requiresOnboarding: true,
      accessPossibleWithRoles: [
        Role.ADMIN,
        Role.MANAGEMENT,
        Role.THERAPIST,
        Role.PATIENT,
        Role.PREVENTION,
      ],
    },
  },
  {
    ...appendVueRoute<'preventionSuccess'>(
      'preventionSuccess',
      '/prevention-success/:preventionCourseId',
    ),
    component: () => import('@src/views/PreventionSuccess.vue'),
    meta: {
      layout: 'default',
      title: 'Kurs freigeschaltet',
      requiresAuth: true,
      requiresOnboarding: true,
      accessPossibleWithRoles: [
        Role.ADMIN,
        Role.MANAGEMENT,
        Role.THERAPIST,
        Role.PATIENT,
        Role.PREVENTION,
      ],
    },
  },
  {
    ...appendVueRoute<'preventionSuperadmin'>('preventionSuperadmin', '/prevention-superadmin'),
    component: () => import('@src/views/PreventionSuperadmin.vue'),
    meta: {
      layout: 'default',
      title: 'Präventionskurse',
      requiresAuth: true,
      requiresOnboarding: true,
      accessPossibleWithRoles: [Role.SUPERADMIN],
    },
  },
  {
    ...appendVueRoute<'preventionEditor'>(
      'preventionEditor',
      '/prevention-superadmin/:preventionCourseId',
    ),
    component: () => import('@src/views/PreventionEditor.vue'),
    meta: {
      layout: 'default',
      title: 'Präventionskurse',
      requiresAuth: true,
      requiresOnboarding: true,
      accessPossibleWithRoles: [Role.SUPERADMIN],
    },
  },
  {
    ...appendVueRoute<'preventionAdmin'>('preventionAdmin', '/prevention-admin'),
    component: () => import('@src/views/PreventionAdmin.vue'),
    meta: {
      layout: 'default',
      title: 'Präventionskurse',
      requiresAuth: true,
      requiresOnboarding: true,
      accessPossibleWithRoles: [Role.ADMIN, Role.MANAGEMENT, Role.THERAPIST],
    },
  },
] satisfies RestrictedRecordRaw[];

export default routes;
